import { Reveal, Overline } from "@/components/Reveal";

const steps = [
  {
    n: "01",
    title: "Mapeamento",
    text: "Entendemos como a operação funciona hoje — quem faz o quê, com quais ferramentas e em qual ordem.",
  },
  {
    n: "02",
    title: "Diagnóstico",
    text: "Identificamos gargalos e tarefas manuais, onde pessoas apenas transportam informação entre sistemas.",
  },
  {
    n: "03",
    title: "Integração",
    text: "Definimos e conectamos quais sistemas e dados precisam conversar — inclusive sistemas antigos.",
  },
  {
    n: "04",
    title: "Automação",
    text: "Construímos a camada que executa as tarefas repetitivas de forma controlada e previsível.",
  },
  {
    n: "05",
    title: "Validação",
    text: "Testamos com casos reais e ajustamos o processo antes de colocá-lo em produção.",
  },
  {
    n: "06",
    title: "Operação",
    text: "Monitoramos a execução, corrigimos desvios e evoluímos o processo conforme a operação cresce.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" className="relative py-28 md:py-40 border-t border-white/5 bg-[#070707]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <Overline>Método</Overline>
          <h2 className="font-display font-extrabold text-3xl md:text-5xl tracking-tight leading-[1.05] mt-6 max-w-[16ch]">
            Como trabalhamos
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={0.05}>
              <div className="relative grid md:grid-cols-[minmax(0,0.9fr)_1.6fr] gap-6 md:gap-16 py-10 md:py-14 border-t border-white/5 items-start overflow-hidden">
                <span className="font-serif-ed text-[22vw] md:text-[9vw] leading-none text-white/[0.05] absolute -top-4 md:-top-10 left-0 pointer-events-none select-none">
                  {s.n}
                </span>
                <div className="relative z-10">
                  <span className="font-mono text-xs text-neutral-500">
                    Etapa {s.n}
                  </span>
                  <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight mt-3 max-w-[18ch]">
                    {s.title}
                  </h3>
                </div>
                <p className="relative z-10 text-neutral-400 text-lg leading-relaxed md:pt-2 max-w-[52ch]">
                  {s.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-600 max-w-[60ch]">
            Ferramentas específicas são meio, não produto. O foco está no
            processo — não em uma tecnologia isolada.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
